import React from 'react';
import { 
  Box, 
  Skeleton, 
  Typography,
  IconButton 
} from '@mui/material';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';

const CrossingTradesTableSkeleton = () => {
  return (
    <Box
      sx={{
        borderRadius: "4px",
        marginTop: "1px",
        width: "100%",
        marginRight: 1,
      }}
    >
      {/* Legend and Fund Select */}
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: 2 }}>
        {/* Legend */}
        <Box sx={{ display: "flex", alignItems: "center", marginRight: 2 }}>
          <Box
            sx={{
              width: 20,
              height: 20,
              backgroundColor: "#add8e6",
              marginRight: 1,
            }}
          />
          <Skeleton variant="text" width={200} height={20} />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: 20,
              height: 20,
              backgroundColor: "#e0e0e0",
              marginRight: 1,
            }}
          />
          <Skeleton variant="text" width={220} height={20} />
        </Box>
        
        {/* Fund Select */}
        <Box sx={{ marginLeft: "auto" }}>
          <Skeleton
            variant="rectangular"
            width={120}
            height={32}
            sx={{ borderRadius: 1 }}
          />
        </Box>
      </Box>

      {/* Toggle Switch */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          marginBottom: 0,
          marginTop: "-30px",
        }}
      >
        <Skeleton variant="text" width={180} height={20} />
        <IconButton sx={{ fontSize: 40 }}>
          <ToggleOffIcon sx={{ fontSize: 40 }} />
        </IconButton>
      </Box>

      {/* Table Container */}
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "4px",
          marginTop: "1px",
          width: "100%",
          marginRight: 1,
        }}
      >
        <Box sx={{ height: "700px", padding: 2 }}>
          {/* Table Header */}
          <Box sx={{ display: "flex", mb: 2, borderBottom: "1px solid #e0e0e0", pb: 1 }}>
            <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={100} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={100} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={60} height={24} />
          </Box>

          {/* Table Rows - Multiple rows to show scrollable content */}
          {Array.from({ length: 20 }).map((_, index) => (
            <Box key={index} sx={{ display: "flex", mb: 1, py: 0.5 }}>
              <Skeleton variant="text" width={80} height={16} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={100} height={16} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={80} height={16} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={80} height={16} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={80} height={16} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={100} height={16} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={60} height={16} />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CrossingTradesTableSkeleton; 